namespace $ {

	const tag_regexp = /#\w*/g

	type Field_type = ReturnType< $shm_hitalama_map_widget_entity_form_custom['types_supported'] >[ number ]

	export class $shm_hitalama_map_widget_entity_form_custom extends $giper_baza_entity.with({
		Use_for_fields: $giper_baza_atom_link.to( ()=> $shm_hitalama_map_widget ),
		Object_current: $giper_baza_atom_dict,
		Objects: $giper_baza_atom_list,
		Hide_buttons: $giper_baza_atom_bool, //submit/clear
	}) {

		@ $mol_mem
		hide_buttons( next?: boolean ) {
			return this.Hide_buttons(next)?.val(next) ?? false
		}

		@ $mol_mem
		object_current( next?: Record< string, any > ): Record< string, any > {
			return this.Object_current(next)?.val(next) ?? {}
		}

		@ $mol_mem_key
		object_current_value( name: string, next?: any ) {
			const object = this.object_current()
			if( next === undefined ) return object[ name ] ?? ''

			this.object_current({ ...object, [ name ]: next })
			return next
		}

		@ $mol_mem
		objects( next?: readonly any[] ) {
			return this.Objects(next)?.val(next) ?? []
		}

		@ $mol_mem
		widget_with_fields() {
			return this.Use_for_fields()?.remote()
		}
		
		@ $mol_mem
		text(): string {
			const widget = this.widget_with_fields()
			return widget?.data() ?? widget?.text() ?? ''
		}
		
		@ $mol_mem
		fields_parsed() {
			const lines = this.text().split('\n').flatMap( line => line.split('|') ).map( s => s.trim() )

			const dict: Record< string, ReturnType< $shm_hitalama_map_widget_entity_form_custom['field_parse'] > > = {}

			const arr = lines.map( line => {
				const parsed = this.field_parse( line )
				dict[ parsed.name ] = parsed
				return parsed
			} )
			
			return { dict, arr }
		}
		
		@ $mol_action
		field_parse( str: string ) {
			const tags: string[] = []

			const name = str.replaceAll( tag_regexp, tag => {
				tags.push( tag )
				return ''
			} ).trim()
			
			const type_tag = tags.find( t => this.types_supported().includes( t.slice(1) as Field_type ) )

			return {
				tags,
				name, 
				type: (type_tag?.slice(1) ?? 'any') as Field_type,
			}
		}

		@ $mol_mem
		field_names() {
			return this.fields_parsed().arr.map( f => f.name )
		}

		types_supported() {
			return [
				'any',
				'textarea',
				'string',
				'date',
				'period',
				'file',
			] as const
		}

		@ $mol_mem_key
		field_type( name: string ) {
			return this.fields_parsed().dict?.[name].type
		}

		@ $mol_mem_key
		field_tags( name: any ) {
			return this.fields_parsed().dict[name].tags
		}

		@ $mol_action
		obj_add( obj: any ) {
			this.objects( [ ...this.objects(), obj ] )
		}
		
	}

}
